import { render } from "./PatientGeneral.vue?vue&type=template&id=6f245f76"
import script from "./PatientGeneral.vue?vue&type=script&lang=js"
export * from "./PatientGeneral.vue?vue&type=script&lang=js"

import "./PatientGeneral.vue?vue&type=style&index=0&id=6f245f76&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__